import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from '../../comum/Context/auth';
import './index.css';
import { api } from '../../services/api';
import logoSmall from './../../comum/assets/arbor.png';
import {Link, useNavigate}  from 'react-router-dom'; 

import firebase from '../../restaurante/Config/firebase';
import 'firebase/compat/auth';

import Menu   from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';

function Login() {
  const navigate                        = useNavigate();
  const [email, setEmail    ]           = useState('');
  const [senha, setSenha    ]           = useState('');
  const [sucesso, setSucesso]           = useState('');   
  const [cadastrado, setCadastrado]     = useState('');   
  const [codigorest,   setCodigo]       = useState(0);
  const {setLogado }                    = useContext(AuthContext);
    
  const inputRef = useRef(null);
  const [eyesIsClosed, setEyeState]     = useState(false);  

  const toggleShow =() =>{
    if (inputRef.current.type === "password"){
        setEyeState(true)
        inputRef.current.type = "text";
        } else {
          setEyeState(false)
          inputRef.current.type = "password";          
        }
  };

  function LoginUsuario(){
    firebase.auth().signInWithEmailAndPassword(email, senha)
      .then(function(firebaseUser){
        localStorage.setItem("logado", "S");
        setCadastrado('S');    
        PesquisarRestaurante();      
      })
      .catch(function(error){
        localStorage.setItem("logado", "N");
        setCadastrado('N');
      });
  }   
  
  //buscar restaurantes
  function PesquisarRestaurante(){
    api.get('/parceria/cadastro/' + email
    )
    .then(async(retorno) => {
        await
        localStorage.setItem("logado", "S");
        setLogado(true);
        setSucesso('S');  
        navigate('/parceria/pedido/'+retorno.data[0].codigo);
    })
    .catch((err) => {                        
        localStorage.setItem("logado", "N");
        setLogado(false);
        setSucesso('N');  
    });
  };

  function alterarEmail(event){      
    setEmail(event.target.value);
  }

  function alterarSenha(event){      
    setSenha(event.target.value);
  }

  return (  
    <div>
    <Menu />
    <div className="d-flex align-items-center text-center form-container">      
      <form className="form-signin">
        <img className="mb-4 img-logo" src={logoSmall} alt="" />
        <h1 className="h3 mb-3 fw-normal">Login</h1>
        
        <div className="form-floating">
          <input onChange={alterarEmail} type="email" className="form-control" id="floatingInput" placeholder="E-mail" />
          <label htmlFor="floatingInput">E-mail</label>
        </div>

        <div className="form-floating">
          <input onChange={alterarSenha} ref={inputRef} type="password" className="form-control" id="floatingPassword" placeholder="Senha" />
          {/*<button onClick={toggleShow}>{eyesIsClosed ? <eye-fill /> : <eye-fill />}</button>*/}
          <label htmlFor="floatingPassword">Senha</label>
        </div>
        
        <button onClick={LoginUsuario} className="w-100 btn btn-lg btn-success" type="button">Acessar</button>

        {cadastrado === 'N' ? <div className="alert alert-danger mt-2" role="alert">E-mail ou senha inválida.</div> : null}
        {sucesso === 'N' ? <div className="alert alert-danger mt-2" role="alert">Esse e-mail não está associado a um parceiro</div> : null}
        {sucesso === 'S' ? <Link to='/app/home' /> : null}

        <div className="login-links mt-5">
          <Link to="/parceria/resetsenha" className="mx-3 font-link">Esqueci minha senha</Link>
          <Link to="/parceria/novaconta" className="mx-3 font-link">Criar uma conta</Link>
        </div>

        <p className="mt-5 mb-3 text-muted">&copy; Desenvolvido por F2 Enterprise</p>

      </form>
    </div>
    <Footer />
    </div>
  );
}

export default Login;
